module.exports = __webpack_public_path__ + "img/bad.36414f24.png";